import React, { useContext } from "react";
import { observer } from "mobx-react";

import { EventType } from "@gp/models";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";

export default observer(function BetCardBodyTitleSingleOffer() {
	const bet = useContext(MyBetsBetContext);

	const offer = bet.betSlipOffers[0];

	return (
		<>
			{offer.sportData.eventType === EventType.NORMAL ? (
				<div className="bet__title__inner bet--mini__title__inner">
					{offer.sportData.teamOneName} -{" "}
					{offer.sportData.teamTwoName}
				</div>
			) : (
				<div className="bet__title__inner bet--mini__title__inner">
					{offer.sportData.eventName}
				</div>
			)}
		</>
	);
});
